import { Action, createActionGroup, createFeature, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { EventBackupBase } from 'globals/store/backup.data';
import { eventsActions } from './events.era';

const LOAD_BACKUPS = '[backus] LOAD_BACKUPS'

export interface BackupsState {
  backups: EventBackupBase[]
}

const getDefaultBackupsState = (): BackupsState => ({
  backups: []
})

export const backupActions = createActionGroup({
	source: 'Backups',
	events: {
		'Load Backups': (backups: EventBackupBase[]) => ({ backups }),
	}
})

export const backupReducer = createReducer(
	getDefaultBackupsState(),
	on(backupActions.loadBackups, (state, { backups }) => ({ ...state, backups })),
	on(eventsActions.unloadEvent, (state) => getDefaultBackupsState()),
)

export const backupsFeature = createFeature({
	name: 'backups',
	reducer: backupReducer
});

export const backupsStateSelector = createFeatureSelector<BackupsState>(backupsFeature.name)
